const stateroomsRules = {
  rooms: ["required", "positive_integer"],
};

export default stateroomsRules;
